import "./StatusBar.scss";

import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { computed, makeObservable, observable } from "mobx";
import { Tooltip, Button, Tag, Row, Col, Modal, List, Popover, Select } from "antd";
import { useNavigate } from "react-router-dom";

//import { NotificationTray } from "~/components/ui/notificationTray/NotificationTray";
import { WebsocketBadge } from "./WebsocketBadge";
// import { ProgressBar } from "./ProgressBar";
// import { MemoryBadge } from "./MemoryBadge";
//import { Intercom } from "./Intercom";
//import { SpotlightSearchModal } from "./spotlightSearch/SpotlightSearchModal";
import { CountdownWrapper } from "./CountdownWrapper";
import { translateKey as t } from "../../locales/translation";
//import DebugReminder from "~/components/ui/debugReminder/DebugReminder";

import _ from "lodash";
import dayjs from "dayjs";
import { awesomeIcon } from "../../utils/helpers";
import packageJson from "../../../package.json";

interface StatusBarProps {
  navigate: (path: string) => void;
}

// Custom hook
function useRouter() {
  return {
    navigate: useNavigate(),
  };
}

@inject("store")
@observer
class StatusBar extends Component<StatusBarProps> {
  shortcutModalVisible = false;
  private store;

  shortcutData = [
    {
      key: "Esc",
      action: t("lblClearAllSelections", "Clear All Selections"),
    },
    {
      key: "Hold Q",
      action: t("lblQuickDrag", "Quick Drag"),
    },
    {
      key: "Ctrl + Z",
      action: t("lblUndoLastAction", "Undo Last Action"),
    },
    {
      key: "Ctrl + Shift + Z",
      action: t("lblUndoAllActions", "Undo All Actions"),
    },
    {
      key: "Alt + Shift + Left Mouse Click",
      action: t("lblOpenRouteResourceCalendar", "Open Route Resource Calendar"),
    },
    {
      key: "Ctrl + Left Mouse Click",
      action: t("lblMultiSelectRoute", "Multi-Select Route"),
    },
    {
      key: "Ctrl + Shift + 1",
      action: t("lblNodeLassoMultiSelect", "Node Lasso Multi-Select"),
    },
    {
      key: "Ctrl + Shift + 2",
      action: t("lblRouteLassoMultiSelect", "Route Lasso Multi-Select"),
    },
    {
      key: "Ctrl + Shift + S",
      action: t("lblFilterMultiSelectedRoutes", "Filter Multi-Selected Routes"),
    },
    {
      key: "Ctrl + Shift + F",
      action: t("lblClearFilteredRoutes", "Clear Filtered Routes"),
    },
    {
      key: "Ctrl + Shift + Spacebar",
      action: t("lblSpotlightSearch", "Spotlight Search"),
    },
    {
      key: "Ctrl + .",
      action: t("lblSpotlightSearchAlternative", "Spotlight Search (Alternative)"),
    },
    {
      key: "Ctrl + /",
      action: t("lblLaunchMenu", "Launch Menu"),
    },
  ];

  constructor(props) {
    super(props);
    this.store = props.store;

    makeObservable(this, {
      shortcutModalVisible: observable,
      username: computed,
    });
  }

  get username() {
    let user = "";

    if (this.store.user) {
      user = this.store.user.firstName + " " + this.store.user.lastName;
    }

    return user;
  }

  getOS = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "macOS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }
    return os;
  };

  renderShortcutsModal() {
    let dataSource = [];

    let path = window.location.pathname.toLowerCase();
    dataSource = this.shortcutData;

    if (path !== "/dispatch" && path !== "/route") {
      dataSource = [
        {
          key: "Ctrl + Shift + Spacebar",
          action: t("lblSpotlightSearch", "Spotlight Search"),
        },
        {
          key: "Ctrl + .",
          action: t("lblSpotlightSearchAlternative", "Spotlight Search (Alternative)"),
        },
        {
          key: "Ctrl + /",
          action: t("lblLaunchMenu", "Launch Menu"),
        },
      ];
    }

    // Get OS data.
    let os = this.getOS();
    if (os === "macOS") {
      let macDataSource = dataSource.map((element) => {
        let newElement = {
          key: element.key.replace("Ctrl", "⌘"),
          action: element.action,
        };
        return newElement;
      });
      dataSource = macDataSource;
    }

    return (
      <div>
        <Modal
          title={t("lblShortcuts", "Shortcuts")}
          open={this.shortcutModalVisible}
          onOk={() => (this.shortcutModalVisible = false)}
          onCancel={() => (this.shortcutModalVisible = false)}
          cancelButtonProps={{ style: { display: "none" } }}
          className={"shortcutModal"}
          centered
        >
          <List
            size="small"
            dataSource={dataSource}
            renderItem={(item) => (
              <List.Item className={"shortcutItem"}>
                {item.action}
                <span style={{ float: "right" }}>
                  <Button type="primary" size="small" style={{ backgroundColor: "#e7e7e7", borderColor: "#e7e7e7", color: "black" }}>
                    {item.key}
                  </Button>
                </span>
              </List.Item>
            )}
          />
        </Modal>
      </div>
    );
  }

  getPopoverContent = () => {
    const user = this.store.user;

    let provider;

    switch (_.get(user, "provider", "")) {
      case "google":
        provider = (
          <Tag color="magenta">
            <div className="flex items-center">
              {awesomeIcon("google", "1x", { marginRight: 5 }, "brand")}
              <span>Google</span>
            </div>
          </Tag>
        );
        break;

      case "azuread":
        provider = (
          <Tag color="cyan">
            <div className="flex items-center">
              {awesomeIcon("windows", "1x", { marginRight: 5 }, "brand")}
              <span>Microsoft</span>
            </div>
          </Tag>
        );
        break;

      default:
        provider = (
          <Tag color="purple">
            <div className="flex items-center">
              {awesomeIcon("home", "2x", { marginRight: 5 })}
              <span>{t("lblLocal", "Local")}</span>
            </div>
          </Tag>
        );
        break;
    }

    return (
      <div>
        <div className="mb-2">
          <div>
            <b>{t("lblRole", "Role")}</b>
          </div>
          <Tag color="geekblue">{_.get(user, "roles", []).length > 0 && _.get(user, "roles[0]", "")}</Tag>
        </div>

        <div className="mb-2">
          <div>
            <b>{t("lblLoginProvider", "Login Provider")}</b>
          </div>
          {provider}
        </div>

        <div className="mb-2">
          <div>
            <b>{t("lblUsername", "Username")}</b>
          </div>
          <Tag>{_.get(user, "username", "")}</Tag>
        </div>
      </div>
    );
  };

  handleClientChange = (value) => {
    this.store.setClient(value);
    this.props.navigate("/client-home");
  };

  renderClientSelector() {
    return (
      <div>
        <Select
          showSearch
          style={{ width: 200 }}
          placeholder="Select Client"
          optionFilterProp="children"
          size="small"
          onSelect={this.handleClientChange}
          value={this.store.selectedClient}
          filterOption={(input, option) => ((option?.label ?? "") as string).includes(input)}
          filterSort={(optionA, optionB) => ((optionA?.label ?? "") as string).toLowerCase().localeCompare(((optionB?.label ?? "") as string).toLowerCase())}
          options={this.store.clients.map((client) => {
            return { label: client.name, value: client.clientRef };
          })}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="statusBar">
        {this.renderShortcutsModal()}
        <div className="flex-1 ml-2" style={{ lineHeight: "27px" }}>
          {window.location.href.includes("/home") && this.renderClientSelector()}
        </div>
        <Row justify="end" align="middle">
          <Col>
            <Popover content={this.getPopoverContent()} trigger="hover">
              <Tag style={{ height: 24, lineHeight: "22px" }}>
                <span className="truncate">{this.username}</span>
              </Tag>
            </Popover>
          </Col>

          <Col className="md:block hidden">
            <Tooltip
              placement="top"
              title={
                <div style={{ textAlign: "center" }}>
                  <div>{t("lblSessionTimeout", "Session Timeout")}</div>
                  <div style={{ display: "inline-flex", color: "lightgray" }}>
                    Token :
                    <CountdownWrapper
                      expires={dayjs(this.store.user.expires, "x")}
                      format="Dd HH:mm"
                      style={{
                        color: "lightgray",
                        fontSize: "12px",
                        marginLeft: "4px",
                        fontFamily: "inherit",
                      }}
                      onExpiry={() => {
                        if (window.location.hostname !== "localhost") {
                          this.store.signOut(false, t("lblSessionExpiredPleaseLoginAgain", "Session Expired. Please login again."));
                        }
                      }}
                    />
                  </div>
                </div>
              }
            >
              <Tag style={{ marginBottom: -3, height: 24, lineHeight: 22 }} onClick={() => console.log(dayjs.unix(this.store.user.expires))}>
                <CountdownWrapper
                  expires={this.store.user.inactivityTimeoutExpires}
                  style={{
                    fontSize: "12px",
                    fontFamily: "inherit",
                    lineHeight: "22px",
                  }}
                  onExpiry={() => {
                    if (window.location.hostname !== "localhost") {
                      this.store.signOut(false, t("lblInactivityPeriodElapsedPleaseLoginAgain", "Inactivity Period Elapsed. Please login again."));
                    }
                  }}
                />
              </Tag>
            </Tooltip>
          </Col>

          <Col>{/* <NotificationTray /> */}</Col>

          <Col>{/* <MemoryBadge /> */}</Col>

          <Col>
            <WebsocketBadge store={this.store} />
          </Col>

          <Col>
            <Tooltip placement="bottomLeft" title={t("lblLockTheScreen", "Lock the Screen")}>
              <Button style={{ marginRight: "8px", lineHeight: "22px" }} onClick={() => this.store.signOut(false)} icon={awesomeIcon("lock")} size="small" />
            </Tooltip>
          </Col>

          <Col className="md:block hidden">
            <Tooltip placement="bottomLeft" title={t("lblSpotlightSearch", "Spotlight Search")}>
              <Button style={{ marginRight: "8px", lineHeight: "22px" }} onClick={() => (this.store.spotlightSearch.visible = true)} icon={awesomeIcon("search")} size="small" />
            </Tooltip>
          </Col>

          <Col className="md:block hidden">
            <Tooltip placement="bottomLeft" title={t("lblShortcuts", "Shortcuts")}>
              <Button style={{ marginRight: "8px", lineHeight: "22px" }} onClick={() => (this.shortcutModalVisible = true)} icon={awesomeIcon("link")} size="small" />
            </Tooltip>
          </Col>

          {/* {this.store.getPlugin("intercom") && <Col><Intercom /> </Col>} */}

          <Col data-e2e="status-bar-version-number" className="md:block hidden">
            <Tooltip
              placement="bottomLeft"
              title={!this.store.enableConsoleLogs ? t("lblVersionNumber", "Version Number") : t("lblVersionNumberDebugModeEnabled", "Version Number (Debug Mode Enabled)")}
            >
              <Tag
                style={{ userSelect: "none", height: 24, lineHeight: "22px" }}
                onDoubleClick={(e) => {
                  this.store.toggleConsoleLogs(!this.store.enableConsoleLogs);
                }}
                color={this.store.enableConsoleLogs ? "orange" : null}
              >
                {packageJson.version}
              </Tag>
            </Tooltip>
          </Col>
          {/* <SpotlightSearchModal activeOnLaunch={true} />
          <DebugReminder /> */}
        </Row>
      </div>
    );
  }
}

// Wrapper component
const StatusBarWrapper = (props) => {
  const router = useRouter();

  return <StatusBar {...props} navigate={router.navigate} />;
};

export { StatusBarWrapper };
